import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hezi-disks-card" }
const _hoisted_2 = { class: "hezi-disks-card-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icomoon-caret-down" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "弹出", -1)

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    collapseTitle: null
  },
  setup(__props: any) {

const props = __props as {
  title: string
  collapseTitle?: string
}


const isCollapse = ref(false)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(props.title), 1),
    (props.collapseTitle)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["hezi-disks-card-collapse", {collapsed: isCollapse.value}]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isCollapse.value = !isCollapse.value))
        }, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(props.collapseTitle), 1),
          _renderSlot(_ctx.$slots, "collapsebtn", {}, () => [
            _hoisted_4
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["hezi-disks-card-items", {collapsed: isCollapse.value}])
    }, [
      _renderSlot(_ctx.$slots, "carditems")
    ], 2)
  ]))
}
}

})